/**
 * @vuelto-surface
 * mobile: ok
 * desktop: ok
 * strategy: unified
 *
 * Panel paper Square: blanco sobre bg mint. Una unidad visual para Inicio, Cuenta, Soporte, etc.
 */
import React from 'react';
import { View, type StyleProp, type ViewProps, type ViewStyle } from 'react-native';
import { ticketSurfaces } from './ticketSurfaces.styles';

type Props = ViewProps & {
  children?: React.ReactNode;
  style?: StyleProp<ViewStyle>;
  /** Padding interno `spacing.md`. */
  padded?: boolean;
};

export function PaperSheet({ children, style, padded = false, ...rest }: Props) {
  return (
    <View
      {...rest}
      style={[ticketSurfaces.paperSheet, padded ? ticketSurfaces.paperSheetPadded : null, style]}
    >
      {children}
    </View>
  );
}
